module.exports = __webpack_public_path__ + "static/media/2018-02-05-16.34.40.f32d55be.mp4";